var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_495_58",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_495_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 18.4482H7.33301V6.55644L13.7497 0.153198L14.8955 1.29663C15.0025 1.40336 15.0905 1.54819 15.1595 1.73114C15.228 1.91409 15.2622 2.08942 15.2622 2.25712V2.57728L14.2538 6.55644H19.2497C19.7386 6.55644 20.1663 6.73939 20.533 7.10529C20.8997 7.47119 21.083 7.89807 21.083 8.38594V10.2154C21.083 10.3222 21.0714 10.4365 21.0482 10.5585C21.0256 10.6804 20.9913 10.7948 20.9455 10.9015L18.1955 17.3505C18.058 17.6554 17.8288 17.9146 17.508 18.128C17.1872 18.3415 16.8511 18.4482 16.4997 18.4482ZM5.49967 6.55644V18.4482H1.83301V6.55644H5.49967Z",
    fill: "#47C87A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLike);
export default __webpack_public_path__ + "static/media/greenLike.06c374b6dd3f939ee0540857fdcbe9d9.svg";
export { ForwardRef as ReactComponent };